<ng-container *ngIf="!loading">
  <div
    *ngIf="icon"
    class="icon"
    [ngStyle]="{ backgroundImage: 'url(' + icon + ')' }"
  ></div>
  <p>{{ label | translate }}</p>
</ng-container>
<app-loading
  [color]="colorLoading"
  [show]="true"
  width="16"
  *ngIf="loading"
></app-loading>
